<template>
  <div class="new_vip">
    <div class="title_line">
      <el-page-header @back="goBack" content="交班"></el-page-header>
    </div>
    <div class="content" id="printbox">
      <Stat :statData="detailData"></Stat>
      <!-- 表单 -->
      <div class="form_title">交班</div>
      <div class="form_box">
        <el-form :model="formData" label-width="130px" size="small">
          <el-form-item label="备用金额">
            <el-input v-model="formData.pretty_cash" disabled class="form_input_box"></el-input>
          </el-form-item>
          <el-form-item label="现金总收入">
            <el-input v-model="formData.amount" disabled class="form_input_box"></el-input>
          </el-form-item>
          <el-form-item label="上交营业金额">
            <el-input v-model="formData.hand_money" class="form_input_box" @blur="changeMoney(1)" :disabled="isCheck"></el-input>
          </el-form-item>
          <el-form-item label="下发营业金额">
            <el-input v-model="formData.down_money" class="form_input_box" @blur="changeMoney(2)" :disabled="isCheck"></el-input>
          </el-form-item>
          <el-form-item label="班次" v-if="!isCheck">
            <el-select v-model="class_key" class="input_box">
              <el-option
                v-for="(item,index) in classList"
                :key="index"
                :label="item.show_name"
                :value="index">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="button_box" v-if="!isCheck">
      <el-button type="primary" style="margin:20px 10px;" @click="submit()" :disabled="!couldSubmit" v-if="ifPrint" v-print="'#printbox'">确定交班</el-button>
      <el-button type="primary" style="margin:20px 10px;" @click="submit()" :disabled="!couldSubmit" v-else>确定交班</el-button>
      <el-checkbox v-model="ifPrint" label="打印" border></el-checkbox>
      <el-button style="margin:20px 10px" @click="gotoHome()" v-if="showBackButton">返回首页</el-button>
    </div>
    <div class="button_box" v-else>
      <el-button style="margin:20px 10px;" v-print="'#printbox'">打印</el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { employeeOptions,changeDutyData,changeDutySubmit,classSetList } from "@/api/vip"
import Stat from "@/components/vip/changeDutyStat"
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  props: {
    detailMsg: {
      type: Object,
      default: () => {}
    },
    isCheck:{
      type: Boolean,
      default: false
    }
  },
  watch:{
    detailMsg: {
      handler: function(val) {
        this.detailData = Object.assign({},val);
        this.detailData.unionpay = this.detailData.unionpay_amount;
        this.detailData.free_amount = this.detailData.preferential_money;
        this.detailData.total_amount = this.detailData.goods_amount;
        this.formData.amount = this.detailData.cash;
        this.formData.pretty_cash = this.detailData.pretty_cash;
        this.formData.down_money = this.detailData.down_money;
        this.formData.hand_money = this.detailData.hand_money;
      },
      deep: true,
      immediate: true
    },
  },
  data(){
    return{
      detailData: {}, //详细信息
      formData: {
        hand_money: "",
        down_money: "",
        emp_id: "",
      }, //表单信息
      ifPrint: false, //是否打印
      class_id: 0, //班次id
      class_key: 0, //班次index
      classList: [], //班次列表
      couldSubmit: false, //可以提交
      showBackButton: false, //打印后显示返回按钮
      timeValue: [], //时间
    }
  },
  mounted(){
    this.timeValue = this.$route.query.time || [];
    // console.log(this.formData.room_id)
    console.log(this.isCheck)
    if(!this.isCheck){
      this.init();
    }
  },
  methods:{
    init(){
      this.$nextTick(()=>{
        classSetList({token: this.token,app_id: this.app_id}).then(res => {
          if(res.code == 200){
            this.class_id = res.data[0].id;
            this.classList = res.data[0].rule;
            this.classList.forEach(item => {
              if(item.type == 1){
                item.show_name = item.name + "  " + item.start_time + "~次日" + item.end_time;
              }else{
                item.show_name = item.name + "  " + item.start_time + "~" + item.end_time;
              }
            })
          }
        })
      })
      var data = {
        token: this.token,
        app_id: this.app_id,
      }
      if(this.timeValue.length == 2){
        console.log('自定义交班时间',this.timeValue)
        data.start_time = this.timeValue[0]
        data.end_time = this.timeValue[1]
      }
      changeDutySubmit(data).then( res => {
        if(res.code == 200){
          console.log(res.result);
          this.detailData = Object.assign(res.data);
          this.detailData.unionpay = this.detailData.unionpay_amount;
          this.detailData.free_amount = this.detailData.preferential_money;
          this.detailData.total_amount = this.detailData.goods_amount;
          this.detailData.total_all = (Number(this.detailData.preferential_money) + Number(this.detailData.goods_amount)).toFixed(2);
          this.formData.amount = res.data.cash;
          this.formData.pretty_cash = res.data.pretty_cash;
        }else{
          this.$message({
            type: "error",
            message: res.msg
          })
        }
      })
    },
    submit(){
      var data = {
        token: this.token,
        app_id: this.app_id,
        hand_money: this.formData.hand_money,
        down_money: this.formData.down_money,
        class_id: this.class_id,
        class_key: this.class_key,
        start_time: this.timeValue[0],
        end_time: this.timeValue[1]
      }
      if(this.formData.emp_id != ""){
        data.to_uid = this.formData.emp_id;
      }
      // return false;
      changeDutySubmit(data).then(res => {
        if(res.code == 200){
          this.$message({
            type: "success",
            message: "交班成功"
          })
          this.couldSubmit = false;
          if(this.ifPrint){
            this.showBackButton = true;
          }else{
            this.gotoHome();
            // this.$router.go(-2);
          }
        }else{
          this.$message({
            type: "error",
            message: res.msg
          })
        }
      })
    },
    changeMoney(i){
      var all = Number(this.formData.amount)+Number(this.formData.pretty_cash)
      if(i == 1){ //编辑上交金额
        if(Number(this.formData.hand_money) > all){
          this.$message({
            type: "error",
            message: "上交金额不能大于总金额"
          })
          this.couldSubmit = false;
        }else{
          this.formData.down_money = all - Number(this.formData.hand_money);
          this.couldSubmit = true;
        }
      }else{ //编辑下发金额
        if(Number(this.formData.down_money) > all){
          this.$message({
            type: "error",
            message: "下发金额不能大于总金额"
          })
          this.couldSubmit = false;
        }else{
          this.formData.hand_money = all - Number(this.formData.down_money);
          this.couldSubmit = true;
        }
      }
    },
    goBack(){
      this.$router.go(-1);
    },
    gotoHome(){
      this.$router.go(-2);
    },
  },
  components: {
    Stat
  }
}
</script>

<style lang="scss" scoped>
.new_vip{
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
  .title_line{
    height: 34px;
  }
  .content{
    background: #fff;
    padding: 24px 20px 0 24px;
    overflow: auto;
    .form_title{
      width: 90%px;
      border: 1px solid #91D5FF;
      background: #E6F7FF;
      height: 40px;
      line-height: 40px;
      padding-left: 17px;
      color: #21AAFF;
      border-radius: 4px;
    }
    .form_box{
      margin-top:30px;
      padding: 10px;
      .form_input_box{
        width: 300px;
      }
    }
  }
  .button_box{
    background: #fff;
    padding-left: 154px;
  }
}
</style>